// Skeleton — iOS HIG skeleton loader
// Animated shimmer for loading states

import { ReactNode } from 'react';

export function Skeleton({ className = '', width, height, rounded = 'rounded-[8px]' }: { className?: string; width?: string | number; height?: string | number; rounded?: string }) {
  return (
    <div
      data-testid="skeleton"
      className={['relative overflow-hidden bg-[#E5E5EA] dark:bg-white/10', rounded, className].join(' ')}
      style={{ width, height }}
    >
      <div
        className="absolute inset-0"
        style={{
          background: 'linear-gradient(90deg, transparent 0%, rgba(255,255,255,0.5) 50%, transparent 100%)',
          animation: 'shimmer 1.4s linear infinite',
        }}
      />
      <style>{`@keyframes shimmer { 0% { transform: translateX(-100%); } 100% { transform: translateX(100%); } }`}</style>
    </div>
  );
}

export function SkeletonText({ lines = 3, className = '' }: { lines?: number; className?: string }) {
  return (
    <div className={['space-y-2', className].join(' ')} data-testid="skeleton-text">
      {Array.from({ length: lines }).map((_, i) => (
        <Skeleton key={i} height={14} width={i === lines - 1 ? '60%' : '100%'} />
      ))}
    </div>
  );
}

export function SkeletonCard({ children }: { children?: ReactNode }) {
  return (
    <div className="rounded-[16px] bg-white p-4 space-y-2" data-testid="skeleton-card">
      <Skeleton height={16} width="40%" />
      <SkeletonText lines={2} />
      {children}
    </div>
  );
}

export function SkeletonList({ rows = 5 }: { rows?: number }) {
  return (
    <div className="rounded-[12px] bg-white" data-testid="skeleton-list">
      {Array.from({ length: rows }).map((_, i) => (
        <div key={i} className="flex items-center gap-3 p-3 border-b border-[#E5E5EA] last:border-b-0">
          <Skeleton width={36} height={36} rounded="rounded-[10px]" />
          <div className="flex-1 space-y-1.5">
            <Skeleton height={12} width="40%" />
            <Skeleton height={10} width="70%" />
          </div>
        </div>
      ))}
    </div>
  );
}
